import React from 'react'
import { useWindowDimensions, ScrollView, View } from 'react-native'
import { Text, Button, Select, SelectItem, Input } from '@ui-kitten/components'
import tailwind from 'tailwind-rn'
import { useForm, Controller } from "react-hook-form"
import { useMediaQuery } from 'react-responsive'


import Colors from '../constants/Colors'

import { SafeAreaView } from 'react-native-safe-area-context'
import HeaderInterno from '../components/HeaderInterno'
import FooterInterno from '../components/FooterInterno'
import FooterMenu from '../components/FooterMenu'

const assunto = [
  'Informações',
  'Sugestões',
  'Reclamações',
]

export default function FaleConosco() {

  const isLargeScreen = useMediaQuery({minDeviceWidth: 440})
  const windowWidth = isLargeScreen ? 800 : useWindowDimensions().width
  const windowHeight = useWindowDimensions().height
  const { register, setValue, handleSubmit, control, reset, watch, formState: { errors } } = useForm()

  const renderOption = (title, index) => (
    <SelectItem title={title} key={index} />
  )

  const displayValue = (value) => assunto[value.row]

  const _submit = (data) => {
    Email.send({
      SecureToken: "94046e92-e7fd-46c0-8be8-2d62357aca46",
      To : 'senac@ba.senac.br',
      From :  "service.mail@ba.senac.br",
      Subject : assunto[data.assunto.row],
      Body : `Nome: ${data.nome}\nEmail: ${data.email}}\nTelefone: ${data.telefone}}\n${data.mensagem}`
    }).then(
      message => alert(message)
    )
  }


      return (
        <SafeAreaView style={{flex:1, backgroundColor: "#ece7e7"}}>
          <HeaderInterno title="FALE CONOSCO" />
          <ScrollView style={{height: windowHeight, width: windowWidth}}>
            <View style={[tailwind('bg-white mx-7 mt-10 mb-40'), { shadowColor: '#000', shadowOffset: {width: 0, height: 4}, shadowOpacity: 0.5, shadowRadius: 4.85, borderRadius: 20 }]}>
              <View style={[tailwind('mx-5'), {marginTop: isLargeScreen ? 110 : 150}]}>
              <Controller
                control={control}
                render={({field: { onChange, onBlur, value }}) => (
                    <Input
                        onBlur={onBlur}
                        onChangeText={value => onChange(value)}
                        value={value}
                        placeholder="Nome"
                        maxLength={80}
                        style={{marginBottom: 20, borderRadius: 20, borderColor: errors.nome ? 'red' : Colors.cinza_claro, shadowColor: Colors.cinza_forte, shadowOffset: {width: 0, height: 4}, shadowOpacity: 0.5, shadowRadius: 4.85 }}
                        placeholderTextColor={Colors.roxo}
                        size="small"
                    />
                )}
                name="nome"
                rules={{ required: true, maxLength: 80 }}
              />
              {errors.nome && <Text style={tailwind('text-xs text-red-600')}>Preenchimento obrigatório</Text>}
              <Controller
                control={control}
                render={({field: { onChange, onBlur, value }}) => (
                    <Input
                        onBlur={onBlur}
                        onChangeText={value => onChange(value)}
                        value={value}
                        placeholder="Email"
                        maxLength={120}
                        style={{marginBottom: 20, borderRadius: 20, borderColor: errors.telefone ? 'email' : Colors.cinza_claro, shadowColor: Colors.cinza_forte, shadowOffset: {width: 0, height: 4}, shadowOpacity: 0.5, shadowRadius: 4.85 }}
                        placeholderTextColor={Colors.roxo}
                        size="small"
                    />
                )}
                name="email"
                rules={{ required: true, maxLength: 120 }}
              />
              {errors.email && <Text style={tailwind('text-xs text-red-600')}>Preenchimento obrigatório</Text>}
              <Controller
                control={control}
                render={({field: { onChange, onBlur, value }}) => (
                    <Input
                        onBlur={onBlur}
                        onChangeText={value => onChange(value)}
                        value={value}
                        placeholder="Telefone"
                        maxLength={20}
                        style={{marginBottom: 20, borderRadius: 20, borderColor: errors.telefone ? 'red' : Colors.cinza_claro, shadowColor: Colors.cinza_forte, shadowOffset: {width: 0, height: 4}, shadowOpacity: 0.5, shadowRadius: 4.85 }}
                        placeholderTextColor={Colors.roxo}
                        size="small"
                    />
                )}
                name="telefone"
                rules={{ required: true, maxLength: 20 }}
              />
              {errors.telefone && <Text style={tailwind('text-xs text-red-600')}>Preenchimento obrigatório</Text>}
              <Controller
                control={control}
                render={({field: { onChange, onBlur, value }}) => (
                <Select
                  placeholder={<Text style={{color: Colors.roxo}}>Assunto</Text>}
                  style={{marginBottom: 20, borderRadius: 20, borderColor: errors.telefone ? 'red' : Colors.cinza_claro, shadowColor: Colors.cinza_forte, shadowOffset: {width: 0, height: 4}, shadowOpacity: 0.5, shadowRadius: 4.85 }}
                  value={value ? displayValue(value) : null}
                  selectedIndex={value}
                  size="small"
                  onSelect={index => onChange(index)}>
                  {assunto.map(renderOption)}
                </Select>
                )}
                name="assunto"
                rules={{ required: true }}
              />
              {errors.mensagem && <Text style={tailwind('text-xs text-red-600')}>Preenchimento obrigatório</Text>}
              <Controller
                control={control}
                render={({field: { onChange, onBlur, value }}) => (
                    <Input
                        onBlur={onBlur}
                        onChangeText={value => onChange(value)}
                        value={value}
                        placeholder="Mensagem"
                        style={{marginBottom: 20, borderRadius: 20, borderColor: errors.mensagem ? 'red' : Colors.cinza_claro, shadowColor: Colors.cinza_forte, shadowOffset: {width: 0, height: 4}, shadowOpacity: 0.5, shadowRadius: 4.85 }}
                        placeholderTextColor={Colors.roxo}
                        multiline
                        numberOfLines={5}
                        size="small"
                    />
                )}
                name="mensagem"
                rules={{ required: true }}
              />
              {errors.mensagem && <Text style={tailwind('text-xs text-red-600')}>Preenchimento obrigatório</Text>}
              </View>
              <Button nativeID="btn" size="small" onPress={handleSubmit(_submit)} style={[tailwind('self-center'), {marginBottom: 50, borderRadius: 20, backgroundColor: Colors.roxo, shadowColor: Colors.cinza_forte, shadowOffset: {width: 0, height: 4}, shadowOpacity: 0.5, shadowRadius: 4.85 }]}>ENVIAR</Button>
            </View>
            {!isLargeScreen && <FooterInterno />}
          </ScrollView>
          <FooterMenu />
        </SafeAreaView>
      )


}
